import { CombinedGraphQLErrors } from "@apollo/client/errors";

/** Detects auth failures across GraphQL error extensions/messages and raw network errors. */
export function isAuthenticationError(error: unknown): boolean {
  if (CombinedGraphQLErrors.is(error)) {
    return error.errors.some((graphQLError) => {
      const code = graphQLError.extensions?.code;
      if (code === "UNAUTHENTICATED" || code === "UNAUTHORIZED") {
        return true;
      }

      const message = graphQLError.message.toLowerCase();
      return (
        message.includes("unauthorized") ||
        message.includes("unauthenticated") ||
        message.includes("not authorized")
      );
    });
  }

  if (!error || typeof error !== "object") {
    return false;
  }

  const statusCode = (error as { statusCode?: number }).statusCode;
  if (statusCode === 401) {
    return true;
  }

  const message = (error as { message?: string }).message?.toLowerCase() ?? "";
  return (
    message.includes("unauthorized") || message.includes("unauthenticated")
  );
}
